import { styled, Typography } from '@mui/material';

export const CompanyName = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '165px',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '153px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    maxWidth: '200px',
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '300px',
  },
}));
